<script>
import { cn } from '@/lib/utils'

export default {
  name: 'UiCard',
  inheritAttrs: false,
  setup(props, { attrs }) {
    const getClass = () => {
      return cn(
        'rounded-lg border bg-card text-card-foreground shadow-sm',
        attrs.class ?? ''
      )
    }

    return {
      cn,
      getClass
    }
  }
}
</script>

<template>
  <div :class="getClass()">
    <slot></slot>
  </div>
</template>
